document.addEventListener("DOMContentLoaded", function () {
  class LoadMore {
    constructor(root) {
      this.root = root;
      this.gridSel = ".js-grid-items";
      this.btnSel = ".js-load-more-btn";
      this.remainingSel = ".js-count-remaining";
      this.barSel = ".js-progress-bar";
      this.paginationSel = ".js-load-more-pagination";
      this.metaId = "paginate-data";
      this.$grid = () => this.root.querySelector(this.gridSel);
      this.$remaining = () => this.root.querySelector(this.remainingSel);
      this.$bar = () => this.root.querySelector(this.barSel);
      this.$pagination = () => this.root.querySelector(this.paginationSel);
      this.$btn = () => this.root.querySelector(this.btnSel);
      this.$meta = (scope = this.root) => {
        if (!scope) return null;
        if (typeof scope.getElementById === "function") return scope.getElementById(this.metaId);
        return scope.querySelector ? scope.querySelector(`#${this.metaId}`) : null;
      };
      if (this.root.dataset.loadmoreInit === "1") return;
      this.root.dataset.loadmoreInit = "1";
      if (!this.$grid() || (!this.$btn() && !this.$pagination())) return;
      const meta = this.readMeta(this.root);
      this.total = meta.items || 0;
      this.pages = meta.pages || 0;
      this.current_page = meta.current_page || 0;
      this.nextURL = meta.next_url || (this.$btn() && this.$btn().dataset.nextUrl) || null;
      this.current = this.$grid().children.length;
      this.updateUI();
      this.bind();
    }
    normURL(s) {
      if (!s) return null;
      s = String(s).replace(/\\u0026/gi, "&").replace(/&amp;/gi, "&");
      try { s = new URL(s, location.origin).toString(); } catch { }
      return s;
    }
    readMeta(scope = this.root) {
      const tag = this.$meta(scope);
      if (!tag) return {};
      try {
        const j = JSON.parse(tag.textContent || "{}");
        return { items: Number(j.items) || 0, pages: Number(j.pages) || 0, current_page: Number(j.current_page) || 0, next_url: this.normURL(j.next_url || null) };
      } catch { return {}; }
    }
    applyMoreText(el, countLeft) {
      const tpl = el.getAttribute("data-more-text") || this.root.getAttribute("data-more-text") || "Load {count} more {label}";
      const label = el.getAttribute("data-label") || this.root.getAttribute("data-label") || "items";
      el.textContent = tpl.replace("{count}", Math.max(countLeft, 0)).replace("{label}", label);
    }
    updateUI() {
      const grid = this.$grid();
      const btn = this.$btn();
      const wrap = this.$pagination();
      const currentCount = grid ? grid.children.length : (this.current || 0);
      const left = this.total ? Math.max((this.total || 0) - currentCount, 0) : 0;
      if (this.total && currentCount >= this.total) this.nextURL = null;
      const hasNext = !!this.nextURL;
      if (this.$remaining()) this.$remaining().textContent = String(left);
      if (this.$bar()) {
        const pct = this.total ? (currentCount / this.total) * 100 : 0;
        this.$bar().style.width = pct + "%";
      }
      if (wrap) wrap.style.display = hasNext ? "" : "none";
      if (btn) {
        if (!hasNext) {
          delete btn.dataset.nextUrl;
          btn.setAttribute("aria-disabled", "true");
          btn.setAttribute("disabled", "disabled");
          btn.classList.add("is-disabled");
          btn.style.pointerEvents = "none";
        } else {
          btn.dataset.nextUrl = this.nextURL;
          btn.removeAttribute("aria-disabled");
          btn.removeAttribute("disabled");
          btn.classList.remove("is-disabled");
          btn.style.pointerEvents = "";
          this.applyMoreText(btn, left);
        }
      }
    }
    bind() {
      this.root.addEventListener("click", (e) => {
        const btn = e.target.closest(this.btnSel);
        if (!btn) return;
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
        e.preventDefault();
        const m = this.readMeta(this.root);
        this.total = m.items || this.total || 0;
        this.pages = m.pages || this.pages || 0;
        this.current_page = m.current_page || this.current_page || 0;
        // Prefer tracked this.nextURL over DOM—#paginate-data is never updated after fetch,
        // so it stays stale (page 2) and would cause every load-more to repeat page 2.
        this.nextURL = this.nextURL || m.next_url || btn.dataset.nextUrl || null;
        if (!this.nextURL) { this.updateUI(); return; }
        const original = btn.textContent.trim();
        const loading = btn.getAttribute("data-loading-text") || "Loading…";
        btn.textContent = loading;
        const target = this.$grid();
        const beforeCount = target ? target.children.length : 0;
        fetch(this.nextURL, { credentials: "same-origin", headers: { "X-Requested-With": "XMLHttpRequest" } })
          .then(r => r.text())
          .then(html => {
            const doc = new DOMParser().parseFromString(html, "text/html");
            const incoming = doc.querySelectorAll(this.gridSel + " > *");
            const firstNewIndex = beforeCount;
            incoming.forEach(n => target && target.appendChild(n.cloneNode(true)));
            const m2 = this.readMeta(doc);
            if (m2.items) this.total = m2.items;
            if (m2.pages) this.pages = m2.pages;
            if (m2.current_page) this.current_page = m2.current_page;
            this.nextURL = m2.next_url || null;
            if (!this.nextURL) {
              const btnResp = doc.querySelector(this.btnSel);
              this.nextURL = this.normURL(btnResp && btnResp.dataset.nextUrl);
            }
            if (this.pages && this.current_page && this.current_page >= this.pages) this.nextURL = null;
            if (!incoming.length) this.nextURL = null;
            this.current = this.$grid() ? this.$grid().children.length : this.current;
            this.updateUI();
            if (!this.nextURL && this.$pagination()) {
              this.$pagination().style.display = "none";
              this.root.dispatchEvent(new CustomEvent('loadmore:complete', { bubbles: true }));
            }
            const gridNow = this.$grid();
            if (gridNow && gridNow.children[firstNewIndex]) {
              const el = gridNow.children[firstNewIndex];
              const y = el.getBoundingClientRect().top + window.pageYOffset - 80;
              requestAnimationFrame(() => { window.scrollTo({ top: y, behavior: 'smooth' }); btn.focus({ preventScroll: true }); });
            }
            if (typeof window.applyMatchHeightPerRow === "function") {
              window.applyMatchHeightPerRow("[data-match-height]");
            }
            if (typeof window.initializeObservers === "function") {
              window.initializeObservers();
            }
          })
          .catch(err => {
            console.error("Load more error:", err);
            btn.textContent = original;
          });
      });
      const onExternalUpdate = () => {
        const m = this.readMeta(this.root);
        this.total = m.items || this.total || 0;
        this.pages = m.pages || this.pages || 0;
        this.current_page = m.current_page || this.current_page || 0;
        this.nextURL = m.next_url || this.nextURL || (this.$btn() && this.$btn().dataset.nextUrl) || null;
        this.current = this.$grid()?.children.length || this.current || 0;
        this.updateUI();
      };
      document.addEventListener("paginate:page-updated", onExternalUpdate);
      document.addEventListener("collection:page-updated", onExternalUpdate);
      document.addEventListener("blog:page-updated", onExternalUpdate);
    }
  }
  document.querySelectorAll(".js-loadmore").forEach((root) => {
    try { new LoadMore(root); } catch (e) { console.warn(e); }
  });
  window.LoadMore = LoadMore;
  window.initLoadMoreOn = function (root) {
    try { return new LoadMore(root); } catch (e) { console.warn(e); }
  };
});